import { imageMode, NORMAL_AD_SOURCES, LIVE_ADS_CONFIG, AD_TYPE, NATIVE_AD_IDENTITY_TYPES } from './../../../../const/creative';
import _ from 'lodash';
import { ref, computed } from '@vue/composition-api';
import store from './../../../../store/index';

export default function usePerfCreative(): any {
  const previewConfig = ref({});
  const aadvid = computed(() => store.state?.account?.accountInfo?.id || '');

  const CAROUSEL_IMAGE_MODE = {
    square: imageMode.CAROUSEL_IMAGE_SQUARE,
    horizontal: imageMode.CAROUSEL_IMAGE_HORIZONTAL,
  };

  const liveAdsCreativeType2AdTypeValueMap = ((): any => {
    const result = {};
    Object.values(LIVE_ADS_CONFIG).forEach(({ creativeType, type }) => (result[creativeType] = type));

    return result;
  })();

  const checkIsLiveAdsByCreativeType = (creativeType): boolean =>
    Object.keys(liveAdsCreativeType2AdTypeValueMap).map(Number).includes(Number(creativeType));

  const getLiveAdTypeByCreativeType = (creativeType): any => liveAdsCreativeType2AdTypeValueMap[creativeType];

  const getAdTypeByDetail = (creativeDetail): any => {
    const creativeType = creativeDetail?.creative_type;
    const { NATIVE_VIDEO } = NORMAL_AD_SOURCES;

    const { SINGLE_IMAGE, SINGLE_VIDEO, CATALOGUE_VIDEO, CATALOGUE_IMAGE, CAROUSEL_IMAGE } = AD_TYPE();

    if (checkIsLiveAdsByCreativeType(creativeType)) {
      return getLiveAdTypeByCreativeType(creativeType);
    }
    // 原生广告也有可能出现 videoInfo为空的情况 所以这里要 前置判断
    // 原生广告 通过nativeSource或identityType 来判断adType
    if (
      creativeDetail.native_source === NATIVE_VIDEO.value ||
      NATIVE_AD_IDENTITY_TYPES.includes(creativeDetail.identity_type)
    ) {
      return SINGLE_VIDEO.value;
    }

    if (!creativeDetail || (!creativeDetail.video_info && !creativeDetail.image_info)) {
      return SINGLE_VIDEO.value;
    }

    const carouselImageModeList = Object.values(CAROUSEL_IMAGE_MODE);
    const isCarouselImageCreative = carouselImageModeList.includes(Number(creativeDetail.image_mode));

    if (isCarouselImageCreative) {
      return CAROUSEL_IMAGE.value;
    }

    if (creativeDetail.video_info) {
      // DPA视频创意的videoInfo是空对象
      return _.isEmpty(creativeDetail.video_info) ? CATALOGUE_VIDEO.value : SINGLE_VIDEO.value;
    }

    if (creativeDetail.image_info && creativeDetail.image_info.length === 1) {
      // 目录图片创意的imageInfo是空对象
      return _.isEmpty(creativeDetail.image_info) ? CATALOGUE_IMAGE.value : SINGLE_IMAGE.value;
    }

    return '';
  };
  function handlePreviewConfig(adInfoDetail, identityInfo): any {
    const creativeDetail = adInfoDetail?.creatives[0];
    const adType = getAdTypeByDetail(creativeDetail);
    let playUrl = creativeDetail?.video_info?.main_url || creativeDetail?.video_info?.play_url;
    playUrl = playUrl ?? '';
    const removeProtocol = (url = ''): string => url.replace(/^https?:/, '');
    const isRealTimeLive = adType === AD_TYPE().VIDEO_LIVE.value;
    const isCatalogVideo = adType === AD_TYPE().CATALOGUE_VIDEO.value;
    const isNative = Boolean(creativeDetail?.item_source);
    previewConfig.value = {
      apps: adInfoDetail?.flows,
      info: {
        name: identityInfo?.display_name ?? '',
        avatar: identityInfo?.avatar_icon?.url ?? '',
      },
      material: {
        type: 'video',
        label: creativeDetail.title ?? '',
        actionLabel: creativeDetail.call_to_action,
        media: {
          ...(creativeDetail.video_info ?? {}),
          // ...imageInfo,
          posterUrl: creativeDetail?.video_info?.cover_url,
          playUrl: playUrl && playUrl?.startsWith('http') ? playUrl : removeProtocol(atob(playUrl)),
        },
      },
      additionalInfo: {},
      placementControl: {
        tiktokLiveAds: isRealTimeLive,
        isTiktokFollowIconVisible: isNative,
      },
      otherInfo: {
        aadvid: aadvid.value,
        pangleIframeData: {
          adType,
          isUnderNormalNativeAd: isNative,
          creativeFormData: {
            adType,
            isProductSalesCatalogVideo: isCatalogVideo,
            ...creativeDetail.value,
          },
        },
      },
    };
  }

  return {
    handlePreviewConfig,
    previewConfig,
  };
}
